var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SocialImage',{attrs:{"title":"Twitter","channel":_vm.channel}})}
var staticRenderFns = []

export { render, staticRenderFns }